module.exports = __webpack_public_path__ + "img/04—02—Phonebook > IB Plus.38608be0.jpg";